import { fetchWrapper } from "src/helpers";

const baseUrl = "/api/dashboard/performance";

export interface PerformanceParams {
  page?: number;
  limit?: number;
  fromDate?: string;
  toDate?: string;
  symbol?: string;
  universe_name?: string;
  indicesname?: string;
  date?: string;
  heatmapDate?: string;
  sortBy?: string;
  sortOrder?: string;
  [key: string]: string | number | boolean | undefined;
}

const buildQueryString = (params?: PerformanceParams) => {
  if (!params) return "";
  const stringParams: Record<string, string> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      stringParams[key] = String(value);
    }
  });
  const searchParams = new URLSearchParams(stringParams);
  const query = searchParams.toString();
  return query ? `?${query}` : "";
};

export const performanceService = {
  getHeatmap: (params?: PerformanceParams) => {
    return fetchWrapper.get(`${baseUrl}/heatmap${buildQueryString(params)}`);
  },
  getList: (params?: PerformanceParams) => {
    return fetchWrapper.get(`${baseUrl}/list${buildQueryString(params)}`);
  },
  getTopPerformers: (params?: PerformanceParams) => {
    return fetchWrapper.get(
      `${baseUrl}/top-performers${buildQueryString(params)}`,
    );
  },
  getIndexPerformance: (params?: PerformanceParams) => {
    return fetchWrapper.get(
      `${baseUrl}/index-performance${buildQueryString(params)}`,
    );
  },
  getIndexChart: (params?: PerformanceParams) => {
    return fetchWrapper.get(
      `${baseUrl}/index-chart${buildQueryString(params)}`,
    );
  },
  getExportUrl: (params?: PerformanceParams) =>
    `${baseUrl}/export${buildQueryString(params)}`,
};
